import { stateToHTML } from 'draft-js-export-html'
import { stateFromHTML } from 'draft-js-import-html'

export const fromContentState = function (s) {
  return stateToHTML(s)
}

export const toContentState = function (v) {
  return stateFromHTML(v)
}
